import { Injectable } from '@angular/core';
import { LoggerService } from './../logger.service';
import { SecureService } from './secure.service';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    constructor(private secureService: SecureService, private customLogger: LoggerService) {}

    set(key: string, value: string): void {
        this.secureService.secureLocalStorage.setItem(key, JSON.stringify(value));
    }

    get(key: string): any {
        // if (key != 'auth_user' && key != 'auth-token' && key != 'app-theme') {
        //     const size = this.getTotalSize();
        //     if (parseInt(size) > 9) {
        //         this.customLogger.info(`------------------------Local Storage ITEMS: ${this.secureService.secureLocalStorage?.length}`);
        //         this.customLogger.info(`------------------------Local Storage SIZE: ${size} mb`);
        //     }
        // }
        return JSON.parse(this.secureService.secureLocalStorage.getItem(key));
    }

    remove(key: string): void {
        this.secureService.secureLocalStorage.removeItem(key);
    }

    clear(): void {
        this.secureService.secureLocalStorage.clear();
    }

    getTotalSize(): string {
        let total = 0;
        for (const x in localStorage) {
            // Value is multiplied by 2 due to data being stored in `utf-16` format, which requires twice the space.
            const amount = (localStorage[x].length * 2) / 1024 / 1024;
            // eslint-disable-next-line no-prototype-builtins
            if (!isNaN(amount) && localStorage.hasOwnProperty(x)) {
                // console.log(x, localStorage.getItem(x), amount);
                total += amount;
            }
        }
        return total.toFixed(2);
    }
}
